<template>
  <div>
    <Header />
    <div style="margin-bottom: 15px;">
      <Content />
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "../../components/private/Header";
import Content from "./components/Contents.vue";
import Footer from "../../components/layout/Footer.vue";
export default {
  components: {
    Header,
    Content,
    Footer,
  },
};
</script>

<style scoped>
.main {
  background: #fff;
  margin-bottom: 30px;
}
</style>
